module.exports={
	"Form": "MixDesignCreateManifest",
	"Scope": "MixDesign-Create",
	"Descriptors":
	{
		"MixDesignDetails.MaterialCode":
		{
			"Name": "Material Code",
			"Hash": "MixDesign-Create-MaterialCode",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "1",
				"Width": 4,
				"Section": "MixDesign-Create-Identity",
				"Group": "MixDesign-Create-Identity"
			}
		},
		"MixDesignDetails.Name":
		{
			"Name": "Name",
			"Hash": "MixDesign-Create-Name",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "1",
				"Width": 6,
				"Section": "MixDesign-Create-Identity",
				"Group": "MixDesign-Create-Identity"
			}
		},
		"MixDesignDetails.IDMaterial":
		{
			"Name": "Material",
			"Hash": "MixDesign-Create-IDMaterial",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Picker",
				"Row": "2",
				"Width": 4,
				"Section": "MixDesign-Create-Details",
				"Group": "MixDesign-Create-Details",
				"Entity": "Material",
				"SearchFields":
				[
					"Name",
					"MaterialCode",
					"ItemCode"
				]
			}
		},
		"MixDesignDetails.IDOrganization":
		{
			"Name": "Organization",
			"Hash": "MixDesign-Create-IDOrganization",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Picker",
				"Row": "2",
				"Width": 4,
				"Section": "MixDesign-Create-Details",
				"Group": "MixDesign-Create-Details",
				"Entity": "Organization",
				"SearchFields":
				[
					"Name",
					"VendorCode",
					"FederalTaxCode"
				]
			}
		},
		"MixDesignDetails.LPSyncDate":
		{
			"Name": "LPSync Date",
			"Hash": "MixDesign-Create-LPSyncDate",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "2",
				"Width": 4,
				"Section": "MixDesign-Create-Details",
				"Group": "MixDesign-Create-Details"
			}
		},
		"MixDesignDetails.HLSyncDate":
		{
			"Name": "HLSync Date",
			"Hash": "MixDesign-Create-HLSyncDate",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "3",
				"Width": 4,
				"Section": "MixDesign-Create-Details",
				"Group": "MixDesign-Create-Details"
			}
		},
		"MixDesignDetails.MixID":
		{
			"Name": "Mix ID",
			"Hash": "MixDesign-Create-MixID",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "3",
				"Width": 4,
				"Section": "MixDesign-Create-Details",
				"Group": "MixDesign-Create-Details"
			}
		},
		"MixDesignDetails.Description":
		{
			"Name": "Description",
			"Hash": "MixDesign-Create-Description",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "TextArea",
				"Row": "4",
				"Width": 12,
				"Section": "MixDesign-Create-Details",
				"Group": "MixDesign-Create-Details"
			}
		},
		"MixDesignDetails.IDMixType":
		{
			"Name": "Mix Type",
			"Hash": "MixDesign-Create-IDMixType",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Picker",
				"Row": "5",
				"Width": 4,
				"Section": "MixDesign-Create-Details",
				"Group": "MixDesign-Create-Details",
				"Entity": "MixType",
				"SearchFields":
				[
					"Name",
					"Code",
					"Description"
				]
			}
		}
	},
	"Sections":
	[
		{
			"Name": "Identity",
			"Hash": "MixDesign-Create-Identity",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Identity",
					"Hash": "MixDesign-Create-Identity",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Details",
			"Hash": "MixDesign-Create-Details",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Details",
					"Hash": "MixDesign-Create-Details",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		}
	]
}
